class Tabs extends HTMLElement {
  constructor() {
    super();
    this.container = this;
    if (!this.container) return;

    this.tabs = this.container.querySelectorAll("x-tab");
    this.panels = document.querySelectorAll("x-tab-panel");

    this.init();
  }

  init() {
    this.tabs.forEach((tab) => {
      tab.addEventListener("click", (event) => this.onTabClick(event));
    });
  }

  onTabClick(event) {
    const clickedTab = event.currentTarget;
    const targetPanelId = clickedTab.getAttribute("aria-controls");

    // Update tab classes
    this.tabs.forEach((tab) => {
      tab.classList.toggle("is-active", tab === clickedTab);
      tab.setAttribute("aria-selected", tab === clickedTab);
    });

    // Show/hide tab panels
    this.panels.forEach((panel) => {
      const isTarget = panel.id === targetPanelId;
      panel.setAttribute("aria-hidden", !isTarget);
    });
  }
}
customElements.define("x-tabs", Tabs);
